import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import Iconmoon from "../IconsFiles/icon";
import { getAllNotifications } from "../../Services/notifications&rolesServices";

export default function BellNotifications() {
   const [notifications, setNotifications] = useState([]);
    const navigate = useNavigate();
  const getTimeAgo = (createdAt) => {
  const now = new Date();
  const created = new Date(createdAt);
  const diffMs = now - created;
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? "s" : ""} ago`;
  const diffHrs = Math.floor(diffMins / 60);
  if (diffHrs < 24) return `${diffHrs} hr${diffHrs > 1 ? "s" : ""} ago`;
  const diffDays = Math.floor(diffHrs / 24);
  return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
};

    useEffect(() => {
      const fetchNotifications = async () => {
        try {
          const res = await getAllNotifications();
          const value = res.notifications.slice(0, 3)?.map((item) => ({
            id: item.id,
            name: item.title,
            tag:
              item.sub_category === "order_approval_request"
                ? "Order Approval Request" : item.sub_category === "system"?"System"
                : item.category,
            time: getTimeAgo(item.created_at),
            type: item.type === "event" ? "event" : "alert",
            isRead: item.read_status,
          }));
          setNotifications(value || []);
        } catch (error) {
          console.error("Failed to fetch notifications:", error);
        }
      };
  
      fetchNotifications();
    }, []);
  
    return (
      
      <div
        style={{
          padding: "8px 6px",
          border: "1px",
          width: "400px",
          borderRadius: "8px",
          display: "flex",
          gap: "8px",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "5px",
          }}
        >
          <span style={{ color: "#605E5C", fontSize: "14px", fontWeight: "400" }}>
            NOTIFICATIONS
          </span>
          <span style={{ color: "#EA655B", fontSize: "14px", fontWeight: "400" }}>
            {notifications.filter((v) => !v.isRead).length} New Notifications
          </span>
        </div>
  
        {notifications.map((value) => (
          <div
            key={value.id}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "97px",
              borderLeft: value.isRead
                ? "4px solid #F3F2F1"
                : value.type === "alert"
                ? "4px solid #EA655B"
                : "4px solid #0268D9",
              backgroundColor: value.isRead ? "white" : "#FAF9F8",
              borderRadius: "5px",
              margin: "0.8% 0%",
              padding: "0.8%",
              paddingInline:"10px",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {value.type === "alert" ? (
                  <Iconmoon icon="warning-icon" size={16} color="#EA655B" />
                ) : value.type === "event" ? (
                  <Iconmoon icon="info_new" size={16} color="#0268D9" />
                ) : (
                  <Iconmoon icon="bell" size={16} color="gray" />
                )}
                <p
                  style={{
                    marginLeft: "10px",
                    fontWeight: 700,
                    fontSize: "14px",
                    color: "black",
                    paddingTop: "10px",
                  }}
                >
                  {value.name}
                </p>
              </div>
  
              {value.isRead && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "3px",
                  }}
                >
                  <Iconmoon icon="seen" size={16} color="gray" />
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "gray",
                    }}
                  >
                    Seen
                  </span>
                </div>
              )}
            </div>
  
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  borderRadius: "40px",
                  border: "1px solid #D2D0CE",
                  padding: "5px 8px",
                  backgroundColor: "#F3F2F1",
                  color: "#605E5C",
                  fontWeight: "400",
                  fontSize: "12px",
                  textTransform: "capitalize",
                }}
              >
                {value.tag}
              </span>
              <span style={{ fontSize: "12px", fontWeight: "700" }}>
                <Iconmoon icon="clock" size={16} color="#A19F9D" /> {value.time}
              </span>
            </div>
          </div>
        ))}
  
        <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Button
            className="textTypeBtn textBtnIcon"
            style={{ color: "#EA655B", border: "none" }}
            onClick={() => navigate("/all-notification")}
          >
            View all notifications
          </Button>
        </div>
      </div>
      
    );
}
